// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__xYrYS","gfeWrapper":"CalendarEvent_gfeWrapper__2xGDt"};